export function getExpirationDate(expirationDate) {

    let expirationMonth = String(parseInt(expirationDate.substr(0, 2)));
    let expirationYear = expirationDate.substr(2, 3);
    let currentDate = new Date();
    let currentMounth = String(currentDate.getMonth() + 1);
    let currentYear = String(currentDate.getFullYear()-2000);
    
    if(currentMounth.length ==1){
        currentMounth = "0"+currentMounth;
    }
    
    if(expirationMonth.length ==1){
        expirationMonth = "0"+expirationMonth;
    }

    let dateCurrent = "01-" + currentMounth + "-" + currentYear;
    let dateExpiration = "01-" + expirationMonth + "-" + expirationYear;
    
    return (
        new Date(dateExpiration.replace(/-/g, "/")).getTime() > 
        new Date(dateCurrent.replace(/-/g, "/")).getTime()
    );
    
  
}